import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from "../../../../environments/environment";
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { Http,Headers,RequestOptions } from '@angular/http';
import { OrdersService } from '../../services/orders/orders.service';
declare var $: any;
const LNG_KEY = "SELECTED_LANGUAGE";


@Component({
  selector: 'app-commanattachdocuments',
  templateUrl: './commanattachdocuments.component.html',
  styleUrls: ['./commanattachdocuments.component.scss']
})
export class CommanattachdocumentsComponent {

  static that:CommanattachdocumentsComponent;

 @Input() documentTypes: string[] = []; // Dynamic document type options
  @Input() fileTypes: string = '*/*'; // Acceptable file types
  @Output() fileUploaded = new EventEmitter<{ files: File[]; documentType: string }>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  selectedDocumentType: string = '';
  fileNames: string[] = [];
 selectFile: any = {};
  data: any = {};
  fileArray: any = [];
  @Input() selectOrderId:any;


 constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
        private decryptpipe: DecryptPipe,
            private cookieService: CookieService,
              private anghttp: Http,
                  private orderService: OrdersService,
 ){}


   DocumentType: any = {
    lable: "Document Type",
    placeholder: "Select Document Type",
    dataField: "DocumentType",
    formControlName: "DocumentType",
    isRequired: false,
    isSearchByApi: true,
    typeOfField: "dropdown",
    isValueBind: true,
  };

  getChangedValue(value, data) {
      if (data.dataField == "DocumentType") {
          this.data[this.DocumentType.dataField] = value.value;
          this.selectedDocumentType=value.value;
          console.log("selectedDocumentType:",this.selectedDocumentType);
      }
  }

   GetDocumentTypeList(value, isScrollDown = false) {
    this.DocumentType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.DocumentType.dropdownList.length / 20) + 1;
    }
    this.orderService
      .getNewDocumentTypes(value)
      .then((res) => {
        let dropdownList = [...res];
        if (
          isScrollDown &&
          res.Total > this.DocumentType.dropdownList.length
        ) {
          dropdownList = dropdownList.concat(
            this.DocumentType.dropdownList
          );
          this.DocumentType = {
            ...this.DocumentType,
            dropdownList: [...dropdownList],
          };
        }
        !isScrollDown &&
          (this.DocumentType = {
            ...this.DocumentType,
            dropdownList: [...dropdownList],
          });
        this.DocumentType.isSearch = false;
      })
      .catch((error) => {
        this.DocumentType.isSearch = false;
      });
  }

onFileSelected(event: Event): void {
  this.fileArray = [];
  const input = event.target as HTMLInputElement;

  if (input.files) {
    this.fileNames = this.fileNames.concat(Array.from(input.files).map(file => file.name));
    this.fileArray = Array.from(input.files);
  }
}


 onSave(): void {
    if (this.selectedDocumentType && this.fileNames.length > 0) {
      const fileInput = document.getElementById('fileInput') as HTMLInputElement;
      if (fileInput.files && fileInput.files.length > 0) {
        const files = Array.from(fileInput.files); 
        this.fileUploaded.emit({
          files: files, 
          documentType: this.selectedDocumentType,
        });
      }
    } else {
      alert('Please select a document type and upload at least one file.');
    }
  }

    Cancel() {
        this.close.emit()
    }

    async Save_Upload() {
   
    if (this.fileArray.length <= 10) {
     
      for await (const element of this.fileArray) {
        this.selectFile = element;
        if (
          this.selectFile == undefined ||
          this.selectFile == "" ||
          this.selectFile == null
        ) {
          this.toastr.error("Please select file to upload", "error");
          $("#fileInput").val("");
          return false;
        }

        //--------------File True Type Validation ---------- added by vithujan 22-09-2022
        var fileReader = new FileReader();
        var isValidFileType = true;
        fileReader.onloadend = function (e: any) {
          var arr = new Uint8Array(e.target.result).subarray(0, 4);
          var header = "";

          for (var i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
          }

          if (
            header.toUpperCase() != "89504E47" &&
            header.toUpperCase() != "FFD8FFE0" &&
            header.toUpperCase() != "FFD8FFE1" &&
            header.toUpperCase() != "25504446"
          ) {
            CommanattachdocumentsComponent.that.toastr.error(
              CommanattachdocumentsComponent.that.translate.instant(
                "SETTING.DocOnly"
              ),
              "Error"
            );
            $("#fileInput").val("");
            isValidFileType = false;
            return false;
          }
        };
        fileReader.readAsArrayBuffer(this.selectFile);
        //----------------------------------------------

        await new Promise(async (resolve1, reject1) => {
          await setTimeout(async () => {
            if (isValidFileType) {
              //--------------Filename Validation ---------- added by vithujan 23-09-2022
              var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
              if (!format.test(this.selectFile.name)) {
                this.toastr.error(
                  this.translate.instant("SETTING.InvalidFile"),
                  "Error"
                );
                $("#fileInput").val("");
                return false;
              }
              //--------------File Type Validation ---------- added by vithujan 15-09-2022
              var meme_type = this.selectFile.type;
              if (
                meme_type.toLowerCase() != "image/jpeg" &&
                meme_type.toLowerCase() != "image/png" &&
                meme_type.toLowerCase() != "application/pdf"
              ) {
                this.toastr.error(
                  this.translate.instant("SETTING.DocOnly"),
                  "Error"
                );
                $("#fileInput").val("");
                return false;
              }
              //end

              //--------------Size Validation----------------
              var bytesize = this.selectFile.size;
              var kbsize: any = 0;
              kbsize = (bytesize / 1000).toFixed(2);
              let IsFileSizeExceed = false;
              if (kbsize > 1024) {
                if (kbsize / 1024 > environment.maxFileSize)
                  IsFileSizeExceed = true;
                else IsFileSizeExceed = false;
              }
              if (IsFileSizeExceed) {
                this.toastr.error(
                  this.translate.instant("SETTING.FileSize"),
                  "Error"
                );
                $("#fileInput").val("");
                return false;
              }
              //----------------------------------------------

              var fd = new FormData();
              if (fd.has("file")) {
                fd.set("file", this.selectFile);
              } else {
                fd.append("file", this.selectFile);
              }
              var headers = new Headers();
              let user_access_token = this.decryptpipe.transform(
                JSON.parse(this.cookieService.get("user_access_token"))
              );
              const token: string = "Bearer " + user_access_token;
              headers.append("Authorization", token);
              let options = new RequestOptions({ headers: headers });
              const apiUrl =
                environment.apiUrl +
                "/api/Document/UploadAttachment?ReferenceId=" +
                this.selectOrderId +
                "&TransectionType=" +
                this.selectedDocumentType +
                "&ParentId=" +
                null;
              const req1 = this.anghttp.post(apiUrl, fd, options).subscribe(
                async (response) => {
                  const updatesucess = await this.translate.instant(
                    "ALERTMESSAGES.updatesucess"
                  );
                  this.toastr.success(updatesucess, "Success");
                  this.close.emit()
                  $("#fileInput").val("");
                  resolve1(updatesucess);
                },
                (err) => {
                  $("#fileInput").val("");
                  this.toastr.error(
                    "Error occured while Uploading...",
                    "error"
                  );
                  reject1("Error occured while Uploading...");
                }
              );
            }
          }, 500);
        });
      }
    } else {
      this.toastr.error("Please select maximum 10 files at a time...", "error");
    }
  }
}
